import {greys, greysDark} from '../../styles/colorStyles';
import {DARK_APP_FOREGROUND_COLOR} from '../dark/darkColorHelpers';
import {LIGHT_APP_FOREGROUND_COLOR} from '../light/lightColorHelpers';
import {
  redesignedDarkAppFrameSemanticStyles,
  redesignedLightAppFrameSemanticStyles,
} from './appFrameSemanticStyles';

export interface SidePanelSemanticStyles {
  panelBackground: string;
  switcherBackground: string;
}

export const lightSidePanelSemanticStyles = {
  panelBackground: LIGHT_APP_FOREGROUND_COLOR,
  switcherBackground: LIGHT_APP_FOREGROUND_COLOR,
} as const satisfies SidePanelSemanticStyles;

export const darkSidePanelSemanticStyles = {
  panelBackground: DARK_APP_FOREGROUND_COLOR,
  switcherBackground: DARK_APP_FOREGROUND_COLOR,
} as const satisfies SidePanelSemanticStyles;

export const redesignedLightSidePanelSemanticStyles: SidePanelSemanticStyles = {
  panelBackground: redesignedLightAppFrameSemanticStyles.mainContentFrame.backgroundColor,
  switcherBackground: greys.shade20,
};

export const redesignedDarkSidePanelSemanticStyles: SidePanelSemanticStyles = {
  panelBackground: redesignedDarkAppFrameSemanticStyles.mainContentFrame.backgroundColor,
  switcherBackground: greysDark.shade10,
};
